import { OpenDcCampaignType } from "hoxton-shared/enums/opendc";
import { DOWNLOAD_FORMAT, PLATFORM } from "hoxton-shared/enums/exports";

export const PlatformLabel = {
    [PLATFORM.DOUBLECLICK]: "Google",
    [PLATFORM.DOUBLECLICK_SV]: "Google Studio Dynamic",
    [PLATFORM.FLASHTALKING]: "Flashtalking",
    [PLATFORM.FLASHTALKING_EXCEL]: "Flashtalking Excel",
    [PLATFORM.FLASHTALKING_ASSETS]: "Flashtalking Assets",
    [PLATFORM.FACEBOOK]: "Meta Ads Manager",
    [PLATFORM.OPENDC]: "Open Media Studio",
    [PLATFORM.CREATIVEX]: "CreativeX",
    [PLATFORM.SATALIA]: "Pre-flight",
    [PLATFORM.GENERIC]: "Generic",
    [PLATFORM.GENERIC_LITE]: "Generic Lite"
} as const;

export const DownloadPlatformsLabels = {
    [DOWNLOAD_FORMAT.DOUBLECLICK]: `${PlatformLabel[PLATFORM.DOUBLECLICK]} Studio HTML`,
    [DOWNLOAD_FORMAT.DOUBLECLICK_SV]: `${PlatformLabel[PLATFORM.DOUBLECLICK_SV]} HTML`,
    [DOWNLOAD_FORMAT.OPENDC]: `${PlatformLabel[PLATFORM.OPENDC]} HTML`,
    [DOWNLOAD_FORMAT.FLASHTALKING]: `${PlatformLabel[PLATFORM.FLASHTALKING]} HTML`,
    [DOWNLOAD_FORMAT.FLASHTALKING_EXCEL]: PlatformLabel[PLATFORM.FLASHTALKING_EXCEL],
    [DOWNLOAD_FORMAT.FLASHTALKING_ASSETS]: PlatformLabel[PLATFORM.FLASHTALKING_ASSETS],

    [DOWNLOAD_FORMAT.GENERIC]: "Generic HTML",
    [DOWNLOAD_FORMAT.GENERIC_LITE]: "Generic Lite HTML",
    [DOWNLOAD_FORMAT.IMAGE_NO_SCALE]: "Image (PNG)",
    [DOWNLOAD_FORMAT.IMAGE]: "Image@x2 (PNG)",
    [DOWNLOAD_FORMAT.IMAGE_JPEG_NO_SCALE]: "Image (JPG)",
    [DOWNLOAD_FORMAT.IMAGE_JPEG]: "Image@x2 (JPG)",
    [DOWNLOAD_FORMAT.PSD]: "PSD",
    [DOWNLOAD_FORMAT.VIDEO]: "Video (MP4)"
} as const;

export const OpenDcCampaignTypeLabel = {
    [OpenDcCampaignType.display]: "Display",
    [OpenDcCampaignType.video]: "Video",
    [OpenDcCampaignType.socialVideo]: "Social Video",
    [OpenDcCampaignType.socialStatic]: "Social Static"
} as const;

export const CreativeXCampaignType = {
    Brand: "BRAND",
    Creator: "CREATOR"
} as const;

export const CreativeXAssetType = {
    Image: "IMAGE",
    Video: "VIDEO"
} as const;

export const PlatformTypeOption = {
    facebookPlatform: "facebook Platform",
    platformMetadata: "Platform metadata"
} as const;
